import axios from 'axios';
import { notification } from 'antd';

export const getRecentCauses = (categoryId, campaignId) => (dispatch) => {
  dispatch({
    type: 'GET_RECENT_CAUSES_FOR_DONATE_MONEY_PAGE_REQUEST',
    payload: { loadingForRecentCauses: true }
  });
  return axios({
    url: '/api/getCampaignByCategoryID',
    method: 'POST',
    data: {
      categoryID: categoryId,
      campaignID: campaignId
    }
  }).then(({ data: response }) => {
    const { data } = response;
    const { campaigns } = data;
    return dispatch({
      type: 'GET_RECENT_CAUSES_FOR_DONATE_MONEY_PAGE_SUCCESS',
      payload: {
        recentCauses: campaigns,
        loadingForRecentCauses: false
      }
    });
  }).catch((error) => {
    notification.error({
      message: 'GET RECENT CAUSES',
      description: error.message
    });

    return dispatch({
      type: 'GET_RECENT_CAUSES_FOR_DONATE_MONEY_PAGE_FAILED',
      payload: { loadingForRecentCauses: false }
    });
  })
}

export const donateUtilityBill = ({ campaigns_id, email, first_name, last_name, phone_number, method, billFile }) => (dispatch) => {
  dispatch({
    type: 'UPLOAD_UTILITY_BILL_REQUEST',
    payload: { loadingForDonationTypes: true }
  });
  return axios({
    url: '/api/upload_bill',
    method: 'POST',
    data: {
      campaigns_id,
      email,
      first_name, 
      last_name, 
      phone_number, 
      method: JSON.stringify(method), 
      billFile: JSON.stringify(billFile)
    }
  }).then(({ data }) => {
    const { flag, message } = data;
    if (!flag) {
      notification.error({
        message: 'UPLOAD UTILITY BILL',
        description: 'Could not process utility bill payment'
      });
      dispatch({
        type: 'UPLOAD_UTILITY_BILL_FAILED',
        payload: { loadingForDonationTypes: false }
      });
      return Promise.reject();
    } else {
      notification.success({
        message: 'UPLOAD UTILITY BILL',
        description: message.message
      });
      return dispatch({
        type: 'UPLOAD_UTILITY_BILL_SUCCESS',
        payload: {
          loadingForDonationTypes: false
        }
      });
    }
  }).catch((error) => {
    notification.error({
      message: 'UPLOAD UTILITY BILL',
      description: error.message
    });

    return dispatch({
      type: 'UPLOAD_UTILITY_BILL_FAILED',
      payload: { loadingForDonationTypes: false }
    });
  })
}

export const donateWithPaypal = ({ campaign_id, users_id, amount, first_name, last_name, email, phone_number }) => (dispatch) => {
  dispatch({
    type: 'DONATE_WITH_PAYPAL_REQUEST',
    payload: { loadingForDonateMoney: true }
  });
  return axios({
    url: '/api/donate_with_paypal',
    method: 'POST',
    data: {
      campaign_id,
      users_id,
      amount,
      first_name,
      last_name,
      email,
      phone_number
    }
  }).then(({ data }) => {
    const { flag } = data;
    if (!flag) {
      notification.error({
        message: 'DONATE WITH PAYPAL',
        description: 'Could not process paypal payment'
      });
      dispatch({
        type: 'DONATE_WITH_PAYPAL_FAILED',
        payload: { loadingForDonateMoney: false }
      });
      return Promise.reject();
    } else {
      notification.success({
        message: 'DONATION',
        description: 'donation payment saved successfully !'
      });
      return dispatch({
        type: 'DONATE_WITH_PAYPAL_SUCCESS',
        payload: {
          loadingForDonateMoney: false
        }
      });
    }
  }).catch((error) => {
    notification.error({
      message: 'DONATE WITH PAYPAL',
      description: error.message
    });

    return dispatch({
      type: 'DONATE_WITH_PAYPAL_FAILED',
      payload: { loadingForDonateMoney: false }
    });
  })
}

export const getDonationTypes = () => (dispatch) => {
  dispatch({
    type: 'GET_DONATION_TYPES_REQUEST',
    payload: { loadingForDonationTypes: true }
  });
  return axios({
    url: '/api/get_donate_your_bills_section',
    method: 'GET'
  }).then(({ data: response }) => {
    const { data } = response;
    return dispatch({
      type: 'GET_DONATION_TYPES_SUCCESS',
      payload: {
        donationTypes: data,
        loadingForDonationTypes: false
      }
    });
  }).catch((error) => {
    notification.error({
      message: 'GET DONATION TYPES',
      description: error.message
    });

    return dispatch({
      type: 'GET_DONATION_TYPES_FAILED',
      payload: { loadingForDonationTypes: false }
    });
  })
}

export const payWithCard = ({ token, campaignId, amount, first_name, phone_number, last_name, email }) => (dispatch) => {
  dispatch({
    type: 'PAY_WITH_CARD_FOR_DONATION_REQUEST',
    payload: { loadingForDonateMoney: true }
  });
  return axios({
    url: '/api/payment_for_campaign_by_stripe',
    method: 'POST',
    data: {
      token,
      campaignID: campaignId,
      amount,
      first_name,
      last_name,
      phone_number,
      email
    }
  }).then(({ data: response }) => {
    const { flag, message } = response;
    if (!flag) {
      notification.error({
        message: 'PAY WITH CARD',
        description: message.error
      });
  
      dispatch({
        type: 'PAY_WITH_CARD_FOR_DONATION_FAILED',
        payload: { loadingForDonateMoney: false }
      });
      return Promise.reject();
    } else {
      notification.success({
        message: 'PAY WITH CARD',
        description: 'Charged successfully !'
      });
      return dispatch({
        type: 'PAY_WITH_CARD_FOR_DONATION_SUCCESS',
        payload: {
          loadingForDonateMoney: false
        }
      });
    }
  }).catch((error) => {
    notification.error({
      message: 'PAY WITH CARD',
      description: error.message
    });

    return dispatch({
      type: 'PAY_WITH_CARD_FOR_DONATION_FAILED',
      payload: { loadingForDonateMoney: false }
    });
  })
}

export const initializeTokenGeneration = (initialize) => (dispatch) => {
  return dispatch({
    type: 'INITIALIZE_TOKEN_GENERATION',
    payload: { loadingForDonateMoney: initialize }
  });
}

export const getCampaignDetails = (id) => (dispatch) => {
  dispatch({
    type: 'GET_CAMPAIGN_DETAILS_REQUEST',
    payload: { loadingForCampaignDetails: true }
  });
  return axios({
    url: '/api/get_campaign_by_id',
    method: 'POST',
    data: {
      campaign_id: id
    }
  }).then(({ data: response }) => {
    const { data } = response;
    return dispatch({
      type: 'GET_CAMPAIGN_DETAILS_SUCCESS',
      payload: {
        campaignDetails: data,
        loadingForCampaignDetails: false
      }
    });
  }).catch((error) => {
    notification.error({
      message: 'GET CAMPAIGN DETAILS',
      description: error.message
    });

    return dispatch({
      type: 'GET_CAMPAIGN_DETAILS_FAILED',
      payload: { loadingForCampaignDetails: false }
    });
  })
}